import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../../../shared/api';
import { defaultDimensionUnit } from '../productDimensions';
import type { ProductDimensionsFormData } from '../types';

/**
 * Pre-fill the dimension unit (cm) once the units are loaded, so dimensions are never saved without a unit.
 * `form` may be null while the edited product is still loading.
 */
export const useDefaultDimensionUnit = <T extends ProductDimensionsFormData>(
  form: T | null,
  setForm: (updater: (prev: T) => T) => void,
) => {
  const { data: dimensionUnits } = useQuery({
    queryKey: ['dimension-units'],
    queryFn: () => api.get('settings/api/dimension-units/?page_size=100'),
  });

  const missingUnit = Boolean(form) && !form.dimension_unit_option;

  useEffect(() => {
    if (!missingUnit) return;
    const unit = defaultDimensionUnit(dimensionUnits);
    if (unit) setForm((prev) => ({ ...prev, dimension_unit_option: unit }));
  }, [missingUnit, dimensionUnits, setForm]);
};
